import { Link, createFileRoute } from '@tanstack/react-router';
import { type ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../features/auth/auth-context';
import { SharedDocumentView } from '../features/my-files/share/shared-document-view';

/**
 * Mở link chia sẻ tài liệu — APM-SHR-d.
 *
 * Nằm **ngoài** `_app` (khác link mời, `_app/invite.$token.tsx`): link `public` phải mở được khi
 * chưa đăng nhập, mà `_app` đá người chưa đăng nhập về `/login`. Đăng nhập rồi ⇒ cửa
 * `/shares/:token` (mọi đối tượng); chưa ⇒ cửa công khai, link khác trả 401 và trang mời đăng
 * nhập kèm `next` quay lại đúng link này.
 */
export const Route = createFileRoute('/s/$token')({ component: SharedLinkPage });

function SharedLinkPage(): ReactNode {
  const { t } = useTranslation();
  const { token } = Route.useParams();
  const { status } = useAuth();

  return (
    <div className="min-h-dvh bg-background text-foreground">
      <header className="flex h-12 items-center border-b border-border px-4">
        <Link to="/" className="text-sm font-medium">
          ChillPM
        </Link>
      </header>
      <main className="mx-auto flex w-full max-w-5xl flex-col gap-4 px-4 py-6">
        {status === 'restoring' ? (
          <p role="status" className="text-sm text-muted-foreground">
            {t('auth.restoringSession')}
          </p>
        ) : (
          <SharedDocumentView
            // Đổi trạng thái đăng nhập ⇒ đổi cửa (công khai ↔ đã đăng nhập).
            key={status}
            target={{ kind: 'link', token, signedIn: status === 'authenticated' }}
          />
        )}
      </main>
    </div>
  );
}
